import(/* webpackMode: "eager", webpackExports: ["AmplifyConfig"] */ "/codebuild/output/src692948387/src/medimo-dev/front/apps/web/app/amplify-config.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DatadogInit"] */ "/codebuild/output/src692948387/src/medimo-dev/front/apps/web/app/datadog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProviderWrapper"] */ "/codebuild/output/src692948387/src/medimo-dev/front/apps/web/app/posthog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/codebuild/output/src692948387/src/medimo-dev/front/apps/web/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692948387/src/medimo-dev/front/apps/web/app/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["BrowserCheck"] */ "/codebuild/output/src692948387/src/medimo-dev/front/apps/web/components/browser-check.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692948387/src/medimo-dev/front/shared/editor/dist/styles.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692948387/src/medimo-dev/front/packages/consult-table/dist/styles.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src692948387/src/medimo-dev/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
